export const environment = {
  production: true,
  apiHost: 'https://test.magic-cut.in',
  name: 'test',
};
